import Vue from 'vue'
import { Button,Input,FormItem,Form,Radio,RadioGroup,Card,Message,Pagination,Row,Col,Image,Tooltip,Backtop,MessageBox,Header,Main,Table,TableColumn,Menu,MenuItem } from 'element-ui'

Vue.prototype.$message = Message;
Vue.prototype.$alert = MessageBox.alert;
Vue.prototype.$confirm = MessageBox.confirm;

Vue.use(Button)
Vue.use(Input)
Vue.use(FormItem)
Vue.use(Form)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(Card)
Vue.use(Pagination)
Vue.use(Row)
Vue.use(Col)
Vue.use(Image)
Vue.use(Tooltip)
Vue.use(Backtop)
Vue.use(Header)
Vue.use(Main)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Menu)
Vue.use(MenuItem)
